import Ajv from "ajv";

export const arrayOfStringsSchema = {
  items: {
    type: "string",
  },
  type: "array",
};

export const entitySchema = {
  additionalProperties: false, // TODO flip this to true when we support extended entites
  properties: {
    primary: { type: "string" },
  },
  required: ["primary"],
  type: "object",
};

const ajv = new Ajv();
export const validateArrayOfStrings = ajv.compile(arrayOfStringsSchema);
export const validateEntitySchema = ajv.compile(entitySchema);

export const prettifyJson = (rawValue: string, numTabs = 4): string => {
  try {
    const parsed = JSON.parse(rawValue);
    return JSON.stringify(parsed, null, numTabs); // Prettify JSON with 4-space indent
  } catch {
    // fallback: leave as-is if invalid JSON
    return rawValue;
  }
};

export const defaultEntitySchema = `{
  "primary": "<insertyoursample>"
}`;

export const wrapJsonLists = (payload: string): string => {
  let parsed: unknown;
  try {
    parsed = JSON.parse(payload);
  } catch {
    return payload;
  }

  if (Array.isArray(parsed)) {
    return `{
      "data": ${payload}
    }`;
  }
  return payload;
};
